import { CorrelationVector } from '@augloop/logging';
import { EventEmitter } from 'eventemitter3';
export class EmptySessionManager extends EventEmitter {
    init() {
        return Promise.resolve();
    }
    sendMessage(_message, _onResponse, _sendOnlyIfConnected) {
    }
    onMessage(_messageType, _messageCallback) {
    }
    forceReconnect() {
        return Promise.resolve();
    }
    closeSession() {
    }
    sendBytes(_buffer) {
    }
    getCorrelationVector() {
        return new CorrelationVector();
    }
    setState(_newState) {
    }
}
//# sourceMappingURL=empty-session-manager.js.map